const get_number_of_weeks = (starting_date, frozen_start, frozen_weeks) => {
	let today     = new Date()
	let diff      = today - new Date(starting_date)
	let days      = new Date(frozen_start) < today ? (diff / ( 1000 * 60 * 60 * 24 )) - frozen_weeks*7 : diff / ( 1000 * 60 * 60 * 24 )
// to display correct number of current week taking into account if frozen_weeks started before today

	return Math.ceil(days/7)
}
export default get_number_of_weeks